<div class="ag-grid-reload">
  <span class="booking-heading mb-4">{{ subTitle }}</span>
  <span
    (click)="handleReload()"
    class="mb-4"
    [ngClass]="{ 'icon-top': currentRoute?.includes('/patients/subscription') }"
    ><button class="reload-btn button_class">Refresh</button></span
  >
</div>

<div class="d-flex justify-content-between align-items-center flex-wrap mb-2">
  <div class="d-inline-flex align-items-center gap-2">
    <label class="form-label mb-0">Show:</label>
    <select
      class="form-select form-select-sm"
      [(ngModel)]="paginationPageSize"
      (change)="onPaginationChanged()"
      style="width: 70px; height: 30px"
    >
      <option *ngFor="let size of [10, 25, 50, 100]" [value]="size">
        {{ size }}
      </option>
    </select>
    Entries
  </div>

  <div class="d-inline-flex align-items-center gap-2">
    <input
      type="text"
      matInput
      autocomplete="off"
      #filtertextbox
      (keyup)="onFilterTextBoxChanged()"
      placeholder="Search.."
      class="search-box"
      style="width: 240px; border-radius: 14px"
    />
  </div>
</div>

<ag-grid-angular
  #agGrid
  class="ag-theme-alpine ag-grid-container"
  [rowData]="rowData"
  [columnDefs]="columnDefs"
  [gridOptions]="gridOptions"
  [pagination]="true"
  [paginationPageSize]="paginationPageSize"
  [rowHeight]="rowHeight"
  [headerHeight]="headerHeight"
  [tooltipShowDelay]="tooltipShowDelay"
  [suppressPaginationPanel]="true"
  [tooltipHideDelay]="tooltipHideDelay"
  (gridReady)="onGridReady($event)"
  (rowClicked)="rowClicked.emit($event)"
  (filterChanged)="onFilterApplied()"
  (paginationChanged)="onPaginationChanged()"
  domLayout="autoHeight"
>
</ag-grid-angular>

<div
  class="table-footer-container d-flex justify-content-between align-items-center flex-wrap mt-3"
>
  <!-- 📄 Record Info with fallback -->
  <div class="record-info">
    <ng-container
      *ngIf="searchedRow || searchedRow === 0; else noSearchContent"
    >
      Records:
      {{
          searchedRow === 0
        ? 0
        : currPage && currPage > 0 ? (currPage - 1) * paginationPageSize + 1 : 0
      }}
      to
      {{
        currPage * paginationPageSize > searchedRow
          ? searchedRow
          : currPage * paginationPageSize
      }}
      of
      {{
        searchedRow || searchedRow === 0
          ? searchedRow
          : noRecordsFound
          ? 0
          : rowData.length || 0
      }}
    </ng-container>  <!--changes by naved just change the Records: logic  -->

    <ng-template #noSearchContent>
      Records:
      {{
        currPage && paginationPageSize
          ? (currPage - 1) * paginationPageSize + 1
          : 0
      }}
      to
      {{
        currPage && paginationPageSize && rowData.length !== undefined
          ? currPage * paginationPageSize > rowData.length
            ? rowData.length
            : currPage * paginationPageSize
          : 0
      }}
      of
      {{
        searchedRow || searchedRow === 0
          ? searchedRow
          : noRecordsFound
          ? 0
          : rowData.length || 0
      }}
    </ng-template>
  </div>

  <!-- 🧾 Total Pages Count -->
  <div class="paging-records">Total Pages: {{ totalPage }}</div>

  <!-- 📑 Pagination Controls -->
  <div class="pagination-wrapper">
    <ul class="pagination mb-0">
      <li class="page-item">
        <a
          class="page-link button_class"
          (click)="onBtPrevious()"
          [ngClass]="{ disabled: currPage === 1 }"
        >
          Previous
        </a>
      </li>

      <li
        *ngFor="let page of paging"
        class="page-item page-number"
        [class.active]="page === currPage"
      >
        <a class="page-link" (click)="gotoPage(page)">
          {{ page }}
        </a>
      </li>

      <li class="page-item">
        <a
          class="page-link button_class"
          (click)="onBtNext()"
          [ngClass]="{ disabled: currPage === totalPage }"
        >
          Next
        </a>
      </li>
    </ul>
  </div>
</div>
